module.exports = __webpack_public_path__ + "img/voip.7430714b.svg";